import React, { useState } from 'react';
import { TagsGroup } from './TagsGroup';
import { Button } from '../Button/Button';
import { SimpleCheckbox } from '../Form/Checkbox/Checkbox';
import { Grid } from '../Grid/Grid';

export function TagsGroupExample(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState<Array<{ id: string; label?: string }>>([
    {
      id: '1',
      label: 'Tag 1',
    },
    {
      id: '2',
      label: 'Tag 2',
    },
    {
      id: '3',
      label: 'Tag 3',
    },
    {
      id: '4',
      label: 'Tag 4',
    },
    {
      id: '5',
      label: 'Tag 5',
    },
    {
      id: '6',
      label: 'Tag 6',
    },
  ]);

  function addTag(): void {
    const lastId = !tags.length ? 0 : Number(tags[tags.length - 1].id);
    setTags([
      ...tags,
      {
        id: `${lastId + 1}`,
        label: `Tag ${lastId + 1}`,
      },
    ]);
  }

  function handleOnRemove(index: number): void {
    setTags(tags.filter((_, i) => i !== index));
  }

  return (
    <>
      <Grid flex>
        <Button size="small" title="Add Tag" onClick={addTag} />
        <SimpleCheckbox label="Loading" value={loading} onChange={() => setLoading(!loading)} />
      </Grid>
      <div
        style={{
          width: '300px',
          backgroundColor: 'white',
          padding: '5px',
          marginTop: '10px',
        }}
      >
        <TagsGroup tags={tags} onRemove={handleOnRemove} onClear={() => setTags([])} loading={loading} />
      </div>
    </>
  );
}
